import { ref } from 'vue'

import { ORDERS } from '@/constants'

function createInitialFilters() {
    return {
        productionNumber: null,
        plannedSendDate__gte: null,
        plannedSendDate__lte: null,
        orderKind_id: ORDERS.ORDER_KIND.ECOMMERCE,
        status_id: `${ORDERS.ORDER_STATUS.NEW},${ORDERS.ORDER_STATUS.ACCEPTED}`
    }
}

export function createEcommerceOrdersState() {
    return {
        orders: ref([]),
        ordersLoading: ref(false),
        filters: ref(createInitialFilters()),
        orderStatusList: ref([]),
        order: ref(null),
        countries: ref([]),
        printers: ref([]),
        createInitialFilters
    }
}
